"use strict";

var primitives = require('./primitives');
module.exports = {
  'text-primary': 'rgba(0, 0, 0, 0.8)',
  'text-secondary': 'rgba(0, 0, 0, 0.54)',
  'text-placeholder-hover': 'rgba(0, 0, 0, 0.54)',
  'text-tertiary': 'rgba(0, 0, 0, 0.4)',
  'text-placeholder': 'rgba(0, 0, 0, 0.4)',
  'text-primary-inverse': 'rgba(255, 255, 255, 1)',
  'text-secondary-inverse': 'rgba(255, 255, 255, 0.72)',
  'text-link': primitives['blue-100'],
  'text-link-hover': primitives['blue-300'],
  'text-green': primitives['green-300'],
  'text-success': primitives['green-300'],
  'text-error': primitives['red-300'],
  'text-red': primitives['red-300']
};